import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from '../../../services/login-service';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { Button } from '../../../../common/components/form-components/button/button';
import { CarouselModule } from 'primeng/carousel';
import { Password } from '../../../../common/components/form-components/password/password';
import { InputComponent } from '../../../../common/components/form-components/input/input';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '../../../../i18n/translate.service';

@Component({
  selector: 'app-password-page',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    PasswordModule,
    ButtonModule,
    DividerModule,
    RippleModule,
    RouterModule,
    Button,
    CarouselModule,
    HttpClientModule,
    InputComponent,
    Password,
  ],
  templateUrl: './password-page.html',
  styleUrl: './password-page.scss',
})
export class PasswordPage implements AfterViewInit {
  @ViewChild('passwordRef') passwordComponent!: any;

  passwordForm: any;
  submitted: boolean = false;
  products = [
    { id: 1, name: 'Budget', image: 'Group.svg' },
    { id: 2, name: 'Premium', image: 'org-detail.svg' },
    { id: 3, name: 'Luxury', image: 'personal-details.svg' },
  ];

  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private mLoginService: LoginService,
    public Route: ActivatedRoute,
    private eleRef: ElementRef,
    readonly i18n: TranslateService
  ) {
    let email;
    if (this.mLoginService.loggedInUserDetails) {
      email = this.mLoginService.loggedInUserDetails.email;
      this.passwordForm = this.fb.group({
        email: [email, [Validators.required, Validators.email]],
        password: ['', [Validators.required]],
        remember: [false],
      });
    } else {
      this.router.navigate(['/login'], {
        relativeTo: this.Route,
      });
      return;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.passwordComponent.focusInput();
    }, 0);
  }

  editPassword() {
    this.router.navigate(['/login'], {
      relativeTo: this.Route,
    });
  }

  onLogin() {
    let payloadForAuthUser = this.setPayloadForAuthUser();
    this.submitted = true;
    if (this.passwordForm.invalid) {
      this.resetLoginForm(false);
      return;
    } else {
      this.loading = true;
      this.mLoginService.onAuthUser(payloadForAuthUser).subscribe({
        next: (res: any) => {
          this.loading = false;
          console.log('Login success:', res);
          window.location.href = environment.coreAppUrl;
          if (res.data == null) {
            this.resetLoginForm(true);
          }
        },
        error: (err) => {
          this.resetLoginForm(true);
          this.loading = false;
        },
      });
    }
  }

  resetLoginForm(showErrors: boolean) {
    this.passwordForm.controls.password.reset();
    this.passwordForm.controls.password.markAsDirty();

    if (showErrors) {
      this.passwordForm.controls.password.setErrors({ password: true });
    } else {
      this.passwordForm.controls.password.updateValueAndValidity({ emitEvent: true });
    }
  }

  setPayloadForAuthUser(): object {
    let userDetail = this.mLoginService.loggedInUserDetails;
    return {
      organizationId: userDetail.organizationIds[0].id,
      email: userDetail.email,
      password: this.passwordForm.controls.password.value,
      ipAddress: 'string',
    };
  }

  onForgotPassword() {
    this.router.navigate(['/login/reset-password'], {
      relativeTo: this.Route,
    });
  }
}
